import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
  }

  get _sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    this._observer = new IntersectionObserver(
      async (entries, observer) => {
        if (!entries[0].isIntersecting) {
          return;
        }

        observer.unobserve(this);
        observer.disconnect();

        const sectionHTML = await this._fetchSectionHTML();
        this._renderSection(this._sectionId, sectionHTML);
      },
      { rootMargin: '0px 0px 300px 0px' }
    );

    this._observer.observe(this);
  }

  async _fetchSectionHTML() {
    if (!this._sectionId) return null;

    let viewedProducts = RecentlyViewed.getProducts();

    const currentProductId = window?.meta?.product?.id;
    if (currentProductId) {
      viewedProducts = viewedProducts.filter(
        (id) => String(id) !== String(currentProductId)
      );
    }

    if (!viewedProducts.length) {
      this._hideSection();
      return null;
    }

    const url = new URL('search', location.origin);
    url.searchParams.set("q", viewedProducts.map((id) => `id:${id}`).join(" OR "));
    url.searchParams.set("resources[type]", "product");
    url.searchParams.set("section_id", this._sectionId);

    const response = await fetch(url, { priority: "low" });

    return await response.text();
  }

  _renderSection(sectionId, html) {
    if (!html) return;

    const fragment = new DOMParser().parseFromString(html, "text/html");
    const newSection = fragment.getElementById(`shopify-section-${sectionId}`);

    if (!newSection) return;

    const newContent =  newSection.querySelector("recently-viewed-products");
    this.replaceChildren(...newContent.childNodes);
  }

  _hideSection() {
    const section = this.closest('[id^="shopify-section-"]');
    if (!section) return;

    section.hidden = true;
  }
}

if (!customElements.get("recently-viewed-products")) {
  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}
